webpackJsonp([35783957827783],{

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _typography = __webpack_require__(22);
	
	var _grayPercentage = __webpack_require__(24);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _shuffle = __webpack_require__(286);
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var roles = (0, _shuffle2.default)(['Christian', 'Husband', 'Developer', 'Designer', 'Musician', 'Mexican']);
	
	var Role = function (_React$Component) {
	  _inherits(Role, _React$Component);
	
	  function Role() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Role);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      currentRole: 0
	    }, _this.timeout = null, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Role.prototype.changeRole = function changeRole() {
	    var _this2 = this;
	
	    var currentRole = this.state.currentRole;
	
	    currentRole++;
	    if (currentRole > roles.length - 1) {
	      currentRole = 0;
	    }
	    this.setState({ currentRole: currentRole });
	    this.timeout = window.setTimeout(function () {
	      _this2.changeRole();
	    }, 2500);
	  };
	
	  Role.prototype.componentDidMount = function componentDidMount() {
	    this.changeRole();
	  };
	
	  Role.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.timeout) {
	      window.clearTimeout(this.timeout);
	    }
	  };
	
	  Role.prototype.render = function render() {
	    var roles = this.props.roles;
	
	    var role = roles[this.state.currentRole];
	
	    // window.X = this
	
	    return Glamor.createElement(
	      'span',
	      {
	        css: {
	          display: 'inline-block',
	          color: 'tomato'
	          // padding: rhythm(0.2),
	          // paddingLeft: rhythm(0.6),
	          // paddingRight: rhythm(0.6),
	          // color: '#555',
	          // background: '#fafad9',
	          // borderRadius: 2,
	          // boxShadow: 'rgba(0,0,0,.05) 6px 6px 0px',
	        }
	      },
	      role
	    );
	  };
	
	  return Role;
	}(_react2.default.Component);
	
	var Bio = function (_React$Component2) {
	  _inherits(Bio, _React$Component2);
	
	  function Bio() {
	    _classCallCheck(this, Bio);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Bio.prototype.render = function render() {
	    return Glamor.createElement(
	      'div',
	      {
	        css: {
	          marginBottom: (0, _typography.rhythm)(2.5),
	          alignItems: 'center',
	          color: (0, _grayPercentage2.default)(45),
	          fontWeight: 900,
	          fontSize: (0, _typography.rhythm)(1.2),
	          lineHeight: (0, _typography.rhythm)(1.6)
	        }
	      },
	      'I am Armando Sosa. A ',
	      Glamor.createElement(Role, { roles: roles }),
	      ' currently living in Guadalajara, Mexico. Welcome to my site.'
	    );
	  };
	
	  return Bio;
	}(_react2.default.Component);
	
	exports.default = Bio;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(79);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(136);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(94);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _grayPercentage = __webpack_require__(24);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _Bio = __webpack_require__(271);
	
	var _Bio2 = _interopRequireDefault(_Bio);
	
	var _typography = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogIndex.prototype.render = function render() {
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	    var posts = (0, _get2.default)(this, 'props.data.allMarkdownRemark.edges');
	
	    return Glamor.createElement(
	      'div',
	      null,
	      Glamor.createElement(_reactHelmet2.default, { title: siteTitle }),
	      Glamor.createElement(_Bio2.default, null),
	      posts.map(function (_ref) {
	        var node = _ref.node;
	
	        var title = (0, _get2.default)(node, 'frontmatter.title') || node.fields.slug;
	        return Glamor.createElement(
	          'div',
	          { key: node.fields.slug },
	          Glamor.createElement(
	            'h3',
	            {
	              style: {
	                marginBottom: (0, _typography.rhythm)(1 / 4)
	              }
	            },
	            Glamor.createElement(
	              _gatsbyLink2.default,
	              {
	                style: {
	                  boxShadow: 'none',
	                  color: '#e17055'
	                },
	                to: node.fields.slug
	              },
	              title
	            )
	          ),
	          Glamor.createElement(
	            'span',
	            {
	              style: {
	                fontSize: (0, _typography.rhythm)(1 / 2),
	                color: (0, _grayPercentage2.default)(50),
	                textTransform: 'uppercase'
	              }
	            },
	            node.frontmatter.date
	          ),
	          Glamor.createElement('p', {
	            dangerouslySetInnerHTML: {
	              __html: node.frontmatter.blurb || node.excerpt
	            }
	          })
	        );
	      })
	    );
	  };
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var shuffle = function shuffle(array) {
	  var currentIndex = array.length,
	      temporaryValue,
	      randomIndex;
	
	  // While there remain elements to shuffle...
	  while (0 !== currentIndex) {
	    // Pick a remaining element...
	    randomIndex = Math.floor(Math.random() * currentIndex);
	    currentIndex -= 1;
	
	    // And swap it with the current element.
	    temporaryValue = array[currentIndex];
	    array[currentIndex] = array[randomIndex];
	    array[randomIndex] = temporaryValue;
	  }
	
	  return array;
	};
	
	exports.default = shuffle;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-71e1a23d6677f1b0d585.js